import Swiper from 'swiper/bundle';
import { throttle, debounce } from 'throttle-debounce';

import { IS_PHONE, BREAKPOINTS, IS_TOUCH } from '../helpers/consts';
import refreshScrollAndTriggers from '../helpers/refreshScrollTriggers';

const wrapperClass = 'js-stories-slider-wrapper';
const slideClass = 'js-stories-slide';

export default () => {
  const sliders = document.querySelectorAll('.js-stories-slider');
  if (!sliders[0]) return;

  const slidersArr = [];

  let windowWidth;
  let sliderInited = false;

  const initSliders = () => {
    // if (windowWidth > BREAKPOINTS.tablet) return;
    sliderInited = true;

    sliders.forEach((el) => {

      // addClasses(el);

      const isSingleSlide = el.querySelectorAll(`.${slideClass}`).length === 1;
      if(isSingleSlide) el.classList.add('is-single-slide');

      // const prevBtn = el.querySelector('.js-history-prev-btn');
      // const nextBtn = el.querySelector('.js-history-next-btn');

      let slider = new Swiper(el, {
				// slidesPerView: 2,
				centeredSlides: true,
        // centeredSlides: false,
        slidesPerView: 'auto',
        spaceBetween: 22,
        autoplay: {
          delay: 1000,
        },
        speed: 2000,
        loop: true,
        allowTouchMove: !isSingleSlide,

        // navigation: {
        //   nextEl: nextBtn,
        //   prevEl: prevBtn,
        // },

        breakpoints: {
          320: {
            spaceBetween: 9,
          },
          768: {
            spaceBetween: 22,
          },
        },
      });
      slidersArr.push(slider);
    });
  };

  const addClasses = (el) => {
    el.classList.add('swiper');
    const wrapper = el.querySelector(`.${wrapperClass}`);

    wrapper.classList.add('swiper-wrapper');

    const slides = el.querySelectorAll(`.${slideClass}`);
    slides.forEach((slide) => {
      slide.classList.add('swiper-slide');
    });
  };

  const removeClasses = () => {
    sliders.forEach((el) => {
      el.classList.remove('swiper');
      const wrapper = el.querySelector(`.${wrapperClass}`);

      wrapper.classList.remove('swiper-wrapper');

      const slides = el.querySelectorAll(`.${slideClass}`);
      slides.forEach((slide) => {
        slide.classList.remove('swiper-slide');
      });
    });
  };
  // const destroySliders = () => {
  //   slidersArr.forEach(slider => {
  //     slider.destroy();
  //   });
  //   removeClasses();
  //   slidersArr.length = 0;
  //   sliderInited = false;
  // }

	if(!IS_PHONE) {
		initSliders();
	} else {
		removeClasses();
		refreshScrollAndTriggers();
	}

  // const resizeHandle = () => {
  //   windowWidth = window.innerWidth;

  //   if (windowWidth <= BREAKPOINTS.tablet) {
  //      if (!sliderInited) initSliders();
  //   } else {
  //     if (sliderInited) destroySliders();
  //   }
  // };


  // resizeHandle();

  // if (IS_TOUCH) {
  //   window.addEventListener('orientationchange', debounce(450, resizeHandle));
  // } else {
  //   window.addEventListener('resize', debounce(300, resizeHandle));
  // };
};
